import styled from '@xstyled/styled-components';
import { animated } from '@react-spring/web';

export const Chevron = animated(styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    stroke: var(--color-black);
  }
`);
